import React, { useRef, useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { api, baseURL } from "../include/api";
import { useCart } from "./context/UserCartCountContext";
import "../styles/HeaderTwo.css";

const HeaderTwo = ({ categoryList }) => {
  useEffect(() => {
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  const handleSuggestionClick = (item) => {
    setSearchQuery(""); // clear input
    setShowSuggestions(false); // close dropdown

    if (item.type === "category") {
      navigate(`/category-products/${item.id}`);
    } else if (item.type === "brand") {
      navigate(`/category-products/${item.id}`); // or change to brand-specific path if needed
    } else if (item.type === "product") {
      navigate(`/product-details/${item.id}`);
    } else if (item.type === "service") {
      navigate(`/service-details/${item.id}`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (searchQuery.trim()) {
        navigate(`/search-list?q=${encodeURIComponent(searchQuery.trim())}`);
        setShowSuggestions(false);
      }
    }

    if (event.key === "ArrowDown") {
      setActiveSuggestionIndex((prev) => (prev + 1) % suggestions.length);
    } else if (event.key === "ArrowUp") {
      setActiveSuggestionIndex(
        (prev) => (prev - 1 + suggestions.length) % suggestions.length,
      );
    }
  };

  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false); // close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLiveSearch = async () => {
    try {
      const response = await api.get(`/search/?q=${searchQuery}`);
      const {
        products = [],
        categories = [],
        brands = [],
      } = response.data.data || {};

      // Clean lowercase query
      const lowerQuery = searchQuery.toLowerCase();

      // Filter results to match only those that start with the search query
      const filteredProducts = products.filter((p) =>
        p.name?.toLowerCase().startsWith(lowerQuery),
      );
      const filteredCategories = categories.filter((c) =>
        c.name?.toLowerCase().startsWith(lowerQuery),
      );
      const filteredBrands = brands.filter((b) =>
        b.name?.toLowerCase().startsWith(lowerQuery),
      );

      const combined = [
        ...filteredProducts.map((p) => ({ ...p, type: "product" })),
        ...filteredCategories.map((c) => ({ ...c, type: "category" })),
        ...filteredBrands.map((b) => ({ ...b, type: "brand" })),
      ];

      setSuggestions(combined);
      setShowSuggestions(true);
    } catch (err) {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchQuery) {
        handleLiveSearch();
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    }, 300);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  const location = useLocation();

  useEffect(() => {
    const id = location.hash.replace("#", "");
    if (!id) return;

    let attempts = 0;
    const maxAttempts = 10;

    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -90;
        const rectTop = el.getBoundingClientRect().top;
        const scrollTop = window.pageYOffset;
        const sectionTop = rectTop + scrollTop + yOffset;

        // Max scroll value to avoid blank space at bottom
        const maxScrollTop =
          document.documentElement.scrollHeight - window.innerHeight;
        const finalScrollTop = Math.min(sectionTop, maxScrollTop);

        window.scrollTo({ top: finalScrollTop, behavior: "smooth" });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToSection, 100);
      }
    };

    setTimeout(scrollToSection, 200); // wait for components to load
  }, [location]);
  return (
    <>
      <div className="header-fixed-wrapper fixed-header">
        <header className="header-middle style-two bg-color-neutral ">
          <div className="container container-lg">
            <nav className="header-inner flex-between">
              {/* Logo Start */}
              <div className="logo">
                <Link to="/" className="link">
                  <img src={"/assets/images/logo/logo-two.png"} alt="Logo" />
                </Link>
              </div>

              <div className="flex-align gap-16">
                <div
                  className="search-category style-two d-flex h-48 search-form d-sm-flex"
                  ref={searchRef}
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (searchQuery.trim()) {
                        navigate(
                          `/search-list?q=${encodeURIComponent(searchQuery.trim())}`,
                        );
                      }
                    }}
                    className="d-flex align-items-center"
                  >
                    <div className=" position-relative w-100">
                      <input
                        className="search-form__input common-input py-13 ps-16 pe-18 rounded-0 border-0"
                        type="search"
                        value={searchQuery}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSearchQuery(value);

                          if (value.trim() === "") {
                            setResults([]);
                            setSuggestions([]);
                            setShowSuggestions(false);
                          }
                        }}
                        placeholder="Search for Products, Brands and More"
                        onFocus={() => setShowSuggestions(true)}
                        onKeyDown={handleKeyDown}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          borderRadius: "0px",
                          border: "none",
                          padding: "9px 9px 9px 0px",
                          backgroundColor: "#f1f1f1",
                          fontSize: "14px",
                          color: "#333",
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      className="bg-main-two-600 flex-center text-xl text-white flex-shrink-0 w-48 hover-bg-main-two-700 d-lg-flex"
                      style={{
                        height: "110%",
                        border: "none",
                        background: "#f1f1f1",
                        cursor: "pointer",
                        padding: "10px 10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                      }}
                    >
                      <i className="ph ph-magnifying-glass" />
                    </button>
                  </form>
                  {loading && <div></div>}
                  {showSuggestions && suggestions.length > 0 ? (
                    <div
                      className="suggestions-container"
                      style={{
                        position: "absolute",
                        marginTop: "2.5%",
                        zIndex: 10,
                        width: "30%",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        maxHeight: "500px", // set max height for scrolling
                        overflowY: "auto", // enable vertical scroll
                      }}
                    >
                      {suggestions?.map((item, index) => (
                        <div
                          key={index}
                          className={`suggestion-item d-flex align-items-center p-2 ${index === activeSuggestionIndex ? "active" : ""}`}
                          onClick={() => handleSuggestionClick(item)}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              index === activeSuggestionIndex
                                ? "#f0f0f0"
                                : "#fff",
                          }}
                        >
                          {item.mainImage || item.imageUrl ? (
                            <img
                              src={
                                baseURL +
                                "/" +
                                (item.mainImage || item.imageUrl)
                              }
                              alt={item.name}
                              style={{
                                width: "50px",
                                height: "55px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <i
                              className="fa fa-search"
                              style={{
                                fontSize: "20px",
                                marginRight: "10px",
                                color: "#555",
                              }}
                            ></i>
                          )}
                          <div>
                            <h6 className="fs-5 mb-2">
                              {item.name || item.serviceCatName}
                            </h6>
                            <p>
                              {item.type.charAt(0).toUpperCase() +
                                item.type.slice(1)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    searchQuery.length > 0 && (
                      <div
                        className="suggestions-container"
                        style={{
                          position: "absolute",
                          marginTop: "2.5%",
                          zIndex: 10,
                          width: "30%",
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div
                          key={1}
                          className={`suggestion-item d-flex align-items-center p-2 `}
                        >
                          <div className="m-1">
                            <h6 className="fs-6">Oops! No Match Found...</h6>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="header-right flex-align d-lg-block ">
                <div className="flex-align flex-wrap gap-32">
                  <UserMenu />
                </div>
              </div>
            </nav>
          </div>
        </header>
        <header
          className="category__button flex-align gap-8 fw-medium p-0 bg-white border-bottom"
          style={{
            marginBottom: "0px",
            borderBottom: "2px solid white", // or use theme color
            height: "100%",
          }}
        >
          <div className="container container-lg">
            <nav className="header-inner d-flex justify-content-between gap-8">
              <div className="flex-align menu-category-wrapper">
                <div
                  className={`main  on-hover-item bg-main-600 text-white
                  }`}
                >
                  <button
                    type="button"
                    className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-white"
                  >
                    <span className="icon text-2xl d-xs-flex d-none">
                      <i className="ph ph-dots-nine" />
                    </span>
                    <span className="d-sm-flex d-none">All</span> Categories
                    <span className="arrow-icon text-xl d-flex">
                      <i className="ph ph-caret-down" />
                    </span>
                  </button>
                  <div className="on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper">
                    <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                      {categoryList?.map((item, index) => {
                        return (
                          <li className="has-submenus-submenu">
                            <Link
                              to={`/category-products/${item.id}`}
                              onClick={() => console.log("Clicked", item.id)}
                              className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                            >
                              <span className="text-xl d-flex">
                                <img
                                  src={baseURL + "/" + item.imageUrl}
                                  style={{ width: "50px" }}
                                />
                              </span>
                              <span>{item.name}</span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <ul className="nav-menu flex-align">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={({ isActive }) =>
                        isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      <b>Home</b>
                    </NavLink>
                  </li>

                  <li className="nav-menu__item">
                    <a
                      href="/#Deal_of_The_Day"
                      className="nav-menu__link"
                      onClick={(e) => {
                        if (window.location.pathname === "/") {
                          e.preventDefault();
                          const id = "Deal_of_The_Day";
                          const el = document.getElementById(id);
                          if (el) {
                            const yOffset = -90;
                            const y =
                              el.getBoundingClientRect().top +
                              window.pageYOffset +
                              yOffset;
                            const maxScroll =
                              document.body.scrollHeight - window.innerHeight;
                            const targetScroll = Math.min(y, maxScroll);
                            window.scrollTo({
                              top: targetScroll,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Deals Of The Day
                    </a>
                  </li>
                  <li className="nav-menu__item">
                    <a
                      href="/#top_selling_products"
                      className="nav-menu__link"
                      onClick={(e) => {
                        if (window.location.pathname === "/") {
                          e.preventDefault();
                          const id = "top_selling_products";
                          const el = document.getElementById(id);
                          if (el) {
                            const yOffset = -90;
                            const y =
                              el.getBoundingClientRect().top +
                              window.pageYOffset +
                              yOffset;
                            const maxScroll =
                              document.body.scrollHeight - window.innerHeight;
                            const targetScroll = Math.min(y, maxScroll);
                            window.scrollTo({
                              top: targetScroll,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Top Selling Products
                    </a>
                  </li>
                  <li className="nav-menu__item">
                    <a
                      href="/#trending_products"
                      className="nav-menu__link"
                      onClick={(e) => {
                        if (window.location.pathname === "/") {
                          e.preventDefault();
                          const id = "trending_products";
                          const el = document.getElementById(id);
                          if (el) {
                            const yOffset = -90;
                            const y =
                              el.getBoundingClientRect().top +
                              window.pageYOffset +
                              yOffset;
                            const maxScroll =
                              document.body.scrollHeight - window.innerHeight;
                            const targetScroll = Math.min(y, maxScroll);
                            window.scrollTo({
                              top: targetScroll,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Trending Products
                    </a>
                  </li>

                  <li className="nav-menu__item">
                    <a
                      href="/#top_brands"
                      className="nav-menu__link"
                      onClick={(e) => {
                        if (window.location.pathname === "/") {
                          e.preventDefault();
                          const id = "top_brands";
                          const el = document.getElementById(id);
                          if (el) {
                            const yOffset = -90;
                            const y =
                              el.getBoundingClientRect().top +
                              window.pageYOffset +
                              yOffset;
                            const maxScroll =
                              document.body.scrollHeight - window.innerHeight;
                            const targetScroll = Math.min(y, maxScroll);
                            window.scrollTo({
                              top: targetScroll,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Top Brands
                    </a>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={({ isActive }) =>
                        isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </header>
      </div>
    </>
  );
};

export default HeaderTwo;

const UserMenu = () => {
  const { totalCartItems, totalWishlistItems } = useCart();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="dropdown"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <button
          className="flex-align flex-column gap-8 item-hover-two"
          type="button"
          id="profileDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ background: "transparent", border: "none" }}
        >
          <span className="text-2xl text-white d-flex position-relative item-hover__text">
            <i className="ph ph-user" />
          </span>
          <span className="text-md text-white item-hover__text d-lg-flex">
            Profile
          </span>
        </button>
        <ul
          className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}
          aria-labelledby="profileDropdown"
        >
          <li>
            <Link
              className="dropdown-item custom-hover fw-bold text-secondary"
              to="/profile/personal-info"
            >
              My Profile
            </Link>
          </li>
          <li>
            <Link
              className="dropdown-item custom-hover fw-bold text-secondary"
              to="/user-notification"
            >
              Notification
            </Link>
          </li>
          <li>
            <Link
              className="dropdown-item custom-hover text-danger fw-bold"
              to="/logout"
            >
              Logout
            </Link>
          </li>
        </ul>
      </div>

      <Link
        to="/wishlist"
        className="flex-align flex-column gap-8 item-hover-two"
      >
        <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
          <i className="ph ph-heart" />
          <span
            className="badge rounded-circle bg-main-two-600 text-white"
            style={{
              position: "absolute",
              top: "-9px",
              right: "-10px",
              minWidth: "18px",
              height: "18px",
              fontSize: "14px",
              padding: "0 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            {totalWishlistItems}
          </span>
        </span>
        <span className="text-md text-white item-hover__text d-lg-flex">
          Wishlist
        </span>
      </Link>

      <Link to="/cart" className="flex-align flex-column gap-8 item-hover-two">
        <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
          <i className="ph ph-shopping-cart-simple" />
          <span
            className="badge rounded-circle bg-main-two-600 text-white"
            style={{
              position: "absolute",
              top: "-9px",
              right: "-13px",
              minWidth: "18px",
              height: "18px",
              fontSize: "14px",
              padding: "0 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            {totalCartItems}
          </span>
        </span>
        <span className="text-md text-white item-hover__text d-lg-flex">
          Cart
        </span>
      </Link>
      <Link
        to="/Orders"
        className="flex-align flex-column gap-8 item-hover-two"
      >
        <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
          <i className="ph ph-package" />
        </span>
        <span className="text-md text-white item-hover__text d-lg-flex">
          My Order
        </span>
      </Link>
    </>
  );
};
